import apihelper from "@/helpers/apihelper";

export default{
    async getCars(context, payload){
        const token = context.rootGetters.token;
        const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/cars/listCars`;
        const data = {
            page_number: payload.PageNumber,
            page_size: payload.PageSize,
            bedrijf: [],
            soort: [],
            q: payload.q,
            actief: payload.actief,
            wagenstatus: [],
            order_by: "id"
        };
        const responseData = await apihelper.fetchPostRequest({
            url,
            token,
            payload: JSON.stringify(data),
            errorMsg: 'Failed to fetch agents.'
        });
        context.commit('setCars', responseData.data);
        context.commit('setPages', Math.ceil(responseData.metadata.count / payload.PageSize));
    },

    async getDocs(context, carId){
        const token = context.rootGetters.token;
        const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/cars/listDocs`;
        const data = {
            linkdoc: carId,
            categorie:[]
        };
        const responseData = await apihelper.fetchPostRequest({
            url,
            token,
            payload: JSON.stringify(data),
            errorMsg: 'Failed to fetch docs.'
        });
        return responseData.data;
    },

    clearCars(context){
        context.commit('setCars', []);
        context.commit('setPages', 0);
    },
}